import React, {Fragment} from "react";
import {EditorField as Editor} from "../../form/editor/editor";
import CodeEditor from "../../form/CodeEditor";
import createElement from '../../../utils/createElement';
import isEqual from "lodash-es/isEqual";
import Collapse from "../../layout/Collapse";
import Button from "../Button";
import {html} from "js-beautify";

const pretty = (content) => {
    return html(content);
}

export default class TemplateEditor extends React.Component {

    constructor(props){
        super(props);
        const r = this.parse();
        this.state = {
            opened: false,
            style: r && r.style,
            content: r && r.content,
            invalid: !r
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext){
        if (prevProps.value + "" !== "" + this.props.value) {
            const r = this.parse();
            if (!r) {
                this.setState({
                    invalid: true
                });
                return;
            }
            if (r.style + "" !== "" + this.state.style || r.content + "" !== "" + this.state.content) {
                this.setState({
                    style: r.style,
                    content: r.content,
                });
            }
        }
    }

    saveStyleChanges = (field, value) => {
        const r = this.parse();
        try{r.styleTag.innerHTML = value;}
        //IE fix
        catch(error){r.styleTag.cssText = value;}
        this.setState({
            style: value,
            content: r.content,
        }, () => {
            this.props.saveChanges && this.props.saveChanges(this.props.name, r.document.documentElement.outerHTML);
        })
    }

    saveContentChanges = (field, value) => {
        const r = this.parse();
        const newValue = value;
        //console.log(newValue);
        //console.log(r.content);
        r.contentTag.innerHTML = newValue;
        if (r.contentTag.innerHTML + "" !== "" + r.content) {
            this.setState({
                style: r.style,
                content: newValue,
            }, () => {
                this.props.saveChanges && this.props.saveChanges(this.props.name, r.document.documentElement.outerHTML);
            });
        }
    }

    parse = () => {
        try {
            const ret = {style: null, content: null};
            const dom = new DOMParser().parseFromString(this.props.value || "<html><head/><body/></html>", 'text/xml');
            let style = this.props.styler || "style#template-style";
            let styleTag = dom.querySelector(style);
            if (!styleTag) {
                styleTag = createElement(style, dom);
                dom.querySelector("head").appendChild(styleTag);
            }
            ret.styleTag = styleTag;
            ret.style = styleTag.innerHTML;
            let content = this.props.content || "body";
            let contentTag = dom.querySelector(content);
            if (!contentTag) {
                contentTag = createElement(content, dom);
                if (content !== "body") {
                    dom.querySelector("body").appendChild(contentTag);
                } else {
                    dom.appendChild(contentTag);
                }
            }
            ret.contentTag = contentTag;

            /*const elems = contentTag.getElementsByTagName('*');

            let i = 0;
            for(; i < elems.length; i++)
            {
                if(elems[i].innerHTML)
                {
                    elems[i].innerHTML = elems[i].innerHTML.trim().replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ');
                }
            }*/

            ret.content = contentTag.innerHTML;
            ret.document = dom;
            return ret;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    render() {
        if (this.state.invalid) return null;
        const disabled = this.props.disabled;
        return (
            <Fragment>
                <Editor
                    {...this.props}
                    style={this.state.style}
                    value={this.state.content}
                    saveChanges={this.saveContentChanges}
                    disabled={disabled}
                />
                <Button block={true} color={this.state.opened ? "primary" : "default"} icon={{lib: "fa", name: "code"}} onClick={() => this.setState({opened: !this.state.opened})}/>
                <Collapse collapsed={!!this.state.opened}>
                    <CodeEditor
                        value={this.state.style}
                        mode="css"
                        saveChanges={this.saveStyleChanges}
                        height="400px"
                        label="Design"
                        disabled={disabled}
                    />
                    <CodeEditor
                        value={pretty(this.state.content)}
                        mode="html"
                        saveChanges={this.saveContentChanges}
                        height="400px"
                        label="HTML"
                        disabled={disabled}
                    />
                </Collapse>
            </Fragment>
        );
    }
}